import { Helmet, HelmetProvider } from "react-helmet-async";

const PrivacyPolicy = () => {

  return (
    <div className="h-screen flex w-full">
      <HelmetProvider>
        <Helmet>
          <title>Simplyenglish AI | Privacy-Policy </title>
        </Helmet>
      </HelmetProvider>

      <div className=" flex align-center h-screen w-full">
        <div className=" w-full bg-white p-5 content-container">
          <p>Privacy Policy for Simply English AI Tutor App</p>

          <p>Effective Date: 4th FEBRUARY 2024</p>

          <p>1. Introduction</p>

          <p>Welcome to the Simply English AI Tutor App (referred to as &quot;the App&quot;). This Privacy Policy is an electronic record under the Information Technology Act, 2000 and the rules made thereunder. This Privacy Policy does not require any physical, electronic, or digital signature by Us and has been published by the provisions of the Information Technology Act, 2000 and the rules made thereunder that require publishing the privacy policy and terms of use on the Platform. Please read the Privacy Policy carefully before using or registering on the Platform or accessing any material, information, or availing any Services through the Platform.</p>

          <p>2. <strong>Information Collection</strong></p>

          <ol>
            <li>
              <p><strong>Personal Information</strong>: We collect personal information to provide and enhance our services. This includes:</p>

              <ul>
                <li>
                  <p><strong>Name, Email Address, Phone Number</strong>: For account registration, personalized communication, and identification purposes.</p>
                </li>
                <li>
                  <p><strong>Contact List</strong>: Explicitly collected to foster a community learning experience, enabling users to connect with their network for collaborative educational activities.</p>
                </li>
                <li>
                  <p><strong>Image Access</strong>: For User Profile Personalization</p>
                </li>
              </ul>
            </li>
            <li>
              <p><strong>Usage Data</strong>: Information on how the App is accessed and used, including lesson interactions and preferences, to improve user experience.</p>
            </li>
          </ol>

          <p><strong>Purpose of Collecting Information</strong></p>

          <p>The collection of personal information, including the Contact List, serves to:</p>

          <ul>
            <li>
              <p><strong>Enhance Learning Experience</strong>: By building a community network, facilitating collaboration and learning.</p>
            </li>
            <li>
              <p><strong>Service Provision</strong>: To deliver and refine the services offered, including learning modules and support services.</p>
            </li>
            <li>
              <p><strong>Platform Integrity</strong>: Ensuring a safe, secure environment for all users.</p>
            </li>
            <li>
              <p><strong>User Engagement</strong>: Informing users about updates, offers, and services.</p>
            </li>
            <li>
              <p><strong>Legal and Regulatory Compliance</strong>: Adhering to legal obligations and platform policies.</p>
            </li>
          </ul>

          <p><strong>Usage of Contact List</strong></p>

          <p>The Contact List is specifically used to:</p>

          <ul>
            <li>
              <p>Enable users to invite their contacts to join the learning community within the App.</p>
            </li>
            <li>
              <p>Facilitate the formation of study groups or networks among users who are already part of the App&#39;s community.</p>
            </li>
            <li>
              <p>Provide personalized recommendations for users to connect with their contacts on the platform.</p>
            </li>
          </ul>

          <p><strong>Data Security</strong></p>

          <p>We are committed to the security of your data and employ various measures to protect your personal information. However, it&#39;s important to recognize that no digital platform can guarantee absolute security.</p>

          <p><strong>Information Sharing</strong></p>

          <p>Your personal information is not sold, rented, or traded with third parties for marketing purposes. We may share information with trusted service providers to assist in delivering the App&#39;s services.</p>

          <p><strong>User Rights</strong></p>

          <ul>
            <li>
              <p><strong>Editing Information</strong>: Users can edit their personal information through their account settings.</p>
            </li>
            <li>
              <p><strong>Deletion Requests</strong>: Users can request the deletion of their account and associated data through the support feature in the App.</p>
            </li>
          </ul>

          <p><strong>Children&#39;s Privacy</strong></p>

          <p>We comply with laws protecting children&#39;s privacy. Users under 18 must have consent from a parent or guardian to use the App.</p>

          <p><strong>Amendments to the Privacy Policy</strong></p>

          <p>We reserve the right to amend this policy. Users will be notified of significant changes within the App.</p>

          <p><strong>Contact Us</strong></p>

          <p>For questions regarding this Privacy Policy, please contact info@simplyenglish.ai.</p>

          <p><strong>Conclusion</strong></p>

          <p>By using the Simply English AI Tutor App, you consent to the practices described in this Privacy Policy.</p>

          <p><strong>Last Updated: February 04, 2024</strong></p>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
